import { AdditionalInfoModalComponent } from '@hb/modules/global/additional-info/additional-info-modal/additional-info-modal.component';
import { AdditionalInfoModalOptions } from '@hb/domain/additional-info.model';
import { ButtonKey, QuestionKey } from '@hb/modules/global/global.constants';
import { HintType } from '@hb/domain';
import { AnalyticsClickDirective } from '@hb/directives';

import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input } from '@angular/core';

import { ApContentModule, ApContentService } from '@ap/content';
import { ApModalService, ModalOptions } from '@ap/modal';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApActionIconComponent, ApIconComponent } from '@ap/icon';
import { ApIconButtonLinkComponent } from '@ap/icon-link';
import { ApButtonComponent } from '@ap/button';

@Component({
    selector: 'additional-info',
    templateUrl: './additional-info.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        ApContentModule,
        AnalyticsClickDirective,
        ApAnalyticsModule,
        ApIconComponent,
        ApActionIconComponent,
        ApIconButtonLinkComponent,
        ApButtonComponent
    ]
})
export class AdditionalInfoComponent {
    protected readonly hintType = HintType;
    private readonly contentService = inject(ApContentService);
    private readonly modalService = inject(ApModalService);

    @Input()
    type: HintType = HintType.ICON_LINK;
    @Input()
    titleKey: string;
    @Input()
    contentKey: string;
    @Input()
    modalUrlKey: string;
    @Input()
    params?: { [key: string]: string };
    @Input() key: QuestionKey | ButtonKey;

    openModal(): void {
        const additionalInfoModalOptions: AdditionalInfoModalOptions = {
            contentKey: this.contentKey,
            params: this.params ? this.params : null
        };
        const modalOptions = new ModalOptions(additionalInfoModalOptions);
        modalOptions.title = this.contentService.get(`${this.titleKey}`);
        this.modalService.open(AdditionalInfoModalComponent, modalOptions);
    }

    getModalUrl(): string {
        return this.contentService.get(`${this.modalUrlKey}`);
    }
}
